import React from "react";
import TableauHomePage from "../TableauHomePage/TableauHomePage";
import LoaderElement from "./LoaderElement";

const Loader = () => {
  return (
    <TableauHomePage>
      <LoaderElement />
    </TableauHomePage>
  );
};

export default Loader;
